import type { Attachment, MessageResponse } from 'stream-chat';
import type { FileItem } from './types';
import { useChannelContentSearch } from '../hooks/useChannelContentSearch';

const FILE_PAGE_LIMIT = 50;

function extractFilesFromMessage(message: MessageResponse): FileItem[] {
  if (!message.attachments?.length) return [];

  const createdAt = message.created_at ? new Date(message.created_at as string) : new Date();

  return message.attachments
    .filter((att: Attachment) => att.type === 'file' && att.asset_url)
    .map((att: Attachment, index: number) => ({
      id: `${message.id}-${index}`,
      fileName: att.title || att.fallback || 'Unknown file',
      url: att.asset_url!,
      createdAt,
      messageId: message.id,
    }));
}

export function useChannelFiles() {
  const { data: files, isLoading } = useChannelContentSearch<FileItem[]>({
    filter: { 'attachments.type': { $in: ['file'] } },
    searchOptions: { limit: FILE_PAGE_LIMIT, sort: { created_at: -1 } },
    transform: (messages) => messages.flatMap(extractFilesFromMessage),
    initialData: [],
  });

  return { files, isLoading };
}
